import React, { lazy, Suspense, FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import GuestGuard from 'src/components/GuestGuard';
import LoadingScreen from 'src/components/LoadingScreen';
import AuthGuard from './components/AuthGuard';
import MainLayout from 'src/layouts/MainLayout';
import TopBar from './components/TopBar';

const LoginViewComponent = lazy(() => import('src/views/auth/LoginView'));
const MainHomeComponent = lazy(() => import('src/views/home'));
const NotFoundView = lazy(() => import('src/views/errors/NotFoundView'));
const TunnelView = lazy(()=> import('src/views/tunnel/index'));
const EstablishingConnectionView = lazy(()=> import('src/views/tunnel/EstablishingConnection'));
const renderRoutes = (): JSX.Element => (
    <Routes>
      <Route path='/404' element={<Suspense fallback={<LoadingScreen />}><NotFoundView /></Suspense>}> </Route>
      <Route path='/' element={<GuestGuard> <Suspense fallback={<LoadingScreen />}><LoginViewComponent /> </Suspense> </GuestGuard>}> </Route>
      <Route path='/login-unprotected' element={<Suspense fallback={<LoadingScreen />}><LoginViewComponent /></Suspense>}> </Route>
      <Route path='/select-tunnel' element={<AuthGuard> <Suspense fallback={<LoadingScreen />}></Suspense><MainHomeComponent /> </AuthGuard>}> </Route>
      <Route  path='*'  element={<Navigate to='/404' />}> </Route>
      <Route path='/app' element={<AuthGuard> <MainLayout><TopBar /></MainLayout></AuthGuard>}>
        <Route path='/app/tunnel' element={<TunnelView />} />
        <Route path='/app/connection' element={<EstablishingConnectionView />} />
        <Route path='*' element={<Navigate to='/404' />}> </Route>
      </Route>
    </Routes>
);

const ValidatorRoutes: FC = () => {
  return (
    renderRoutes()
  );
};

export default ValidatorRoutes;
